import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=563bdea6&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=563bdea6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bdea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563bdea6')) {
      api.createRecord('563bdea6', component.options)
    } else {
      api.reload('563bdea6', component.options)
    }
    module.hot.accept("./Shop.vue?vue&type=template&id=563bdea6&scoped=true", function () {
      api.rerender('563bdea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shop.vue"
export default component.exports